import { CachedDataCollector } from "src/core/base/CachedDataCollector";
import { TrackerVariableType } from "src/core/model/TrackerVariableType";
import { CacheStrategy } from "src/core/model/VariableCollectionMetadata";
import { HttpClient } from "src/util/HttpClient";
import { Logger } from "src/util/Logger";

const IP_API_URL = "https://api.ipify.org?format=json";

/**
 * Collects network-related information.
 * Mirrors Android NetworkCollector — adapted for web.
 */
export class NetworkCollector extends CachedDataCollector {
  private resolvedIp: string | null = null;

  collect(): Map<TrackerVariableType, unknown> {
    const data = new Map<TrackerVariableType, unknown>();

    this.collectWithCache(data, TrackerVariableType.IP_ADDRESS, CacheStrategy.SLOW, () => this.resolvedIp ?? "unknown");
    this.collectIfNeeded(data, TrackerVariableType.REACHABLE, () => navigator.onLine);

    return data;
  }

  /**
   * Fetch the client's public IP address.
   * Called during initialization; result is cached.
   */
  async fetchIp(): Promise<string> {
    try {
      const response = await HttpClient.get<{ ip: string }>(IP_API_URL, { timeout: 5_000 });
      this.resolvedIp = response.ip;
      return this.resolvedIp;
    } catch (error) {
      Logger.warn("Failed to fetch IP address:", error);
      this.resolvedIp = "unknown";
      return this.resolvedIp;
    }
  }
}
